import React from 'react';
import { Img, Text, Input, Icon, Button } from '../../Atoms';
import affiliationAccueilMobile from '../../assets/img/affiliationAccueilMobile.png';
import affiliationAccueil from '../../assets/img/affiliationAccueil.png';
import { AffiliationTextMolecule, AffiliationOptionMolecule, AffiliationButtonMolecule } from '../../Molecules';

function OrganismAffiliationAcceil(props) {
    return (
        <div className="organism-affiliation-accueil-container template-scroll">
            <Img src={affiliationAccueilMobile} className="affiliation-accueil-img-mobile" />
            <Img src={affiliationAccueil} className="affiliation-accueil-img" />
            <Text text="Votre affiliation" className="organism-affiliation-accueil-title" />
            <div className="organism-affiliation-accueil-description">Le saviez-vous ? La couverture frais de santé de votre entreprise est un <span>régime de base obligatoire.</span></div>
            <Text text="Simulez votre cotisation" className="organism-affiliation-accueil-simulation" />
            <Text text="Votre cotisation est calculée en % de vos tranches salariales, ainsi qu’en % de plafond mensuel 2021 (PMSS 3377€)." className="organism-affiliation-accueil-cotisation" />
            <Text text="Votre salaire mensuel brut en €" className="organism-affiliation-accueil-label" />
            <Input className="organism-affiliation-accueil-input" />
            <AffiliationTextMolecule
                title="Base obligatoire"
                price="0,00"
                text="votre couverture"
                className=""
            />
            <div className="organism-affiliation-accueil-icon-ou-container" >
                <Icon icon="OU" size="22px" className="organism-affiliation-accueil-icon-ou" />
            </div>
            <AffiliationTextMolecule
                title="Option facultative"
                price="67,71"
                text="votre couverture et celle de votre enfant/conjoint"
                className=""
            />
            <div className="organism-affiliation-accueil-icon-ou-container">
                <Icon icon="OU" size="22px" className="organism-affiliation-accueil-icon-ou" />
            </div>
            <AffiliationTextMolecule
                title="Option facultative"
                price="99,79"
                text="votre couverture et celle de votre famille"
                className=""
            />
            <div className="organism-affiliation-accueil-garanties" >
                <span>Vous pouvre renforcer vos garanties</span> avec un régime supplémentaire (facultatif)
            </div>
            <Button
                text="Exemple de remboursement"
                className="organism-affiliation-accueil-button"
                boxShadow
            />
            <div className="organism-affiliation-accueil-option" >
                Si vous ajoutez <span>l’option 1</span> facultative à votre contrat (débitée de votre compte bancaire) :
            </div>
            <AffiliationOptionMolecule
                title="68.89€/mois"
                description="pour vous"
            />
            <AffiliationOptionMolecule
                title="135.42€/mois"
                description="pour vous et votre conjoint/enfant"
            />
            <AffiliationOptionMolecule
                title="199.58€/mois"
                description="pour vous et votre famille"
            />
            <div className="organism-affiliation-option-button-container" >
                <AffiliationButtonMolecule
                    confirmerClicked={props.AffiliationConfirmClicked}
                    goBackClicked={props.AffiliationCancelClicked}
                />
            </div>

        </div>
    );
}

export default OrganismAffiliationAcceil;
